import { render } from "./PlayingField.vue?vue&type=template&id=48515755&scoped=true"
import script from "./PlayingField.vue?vue&type=script&lang=js"
export * from "./PlayingField.vue?vue&type=script&lang=js"

import "./PlayingField.vue?vue&type=style&index=0&id=48515755&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48515755"]])

export default __exports__